/**
 * The Learnbee ambient ground: a violet floor rising from the bottom of the
 * viewport, over near-white. Nothing else — the drifting glows that used to sit
 * on top competed with the page's own content for attention.
 *
 * IT MATCHES THE FIRST SCREEN. `HeroBreathing` paints one huge
 * radial gradient anchored at 50% 18%, whose outer stops land as a purple wash
 * along the bottom edge. Every later step of the journey renders this instead,
 * and without the floor the flow visibly changed surface after the landing
 * page. The colours below are that gradient's outer stops (#C79BF0, #C766D8),
 * so the two grounds meet rather than merely coexisting.
 *
 * `position: fixed` and `zIndex: 0`, so a page needs its content in a
 * positioned wrapper above it — see the usage in SignInPage.
 */

export function Ambient() {
  return (
    <div aria-hidden style={{ position: 'fixed', inset: 0, zIndex: 0, overflow: 'hidden', background: '#FDFCFE' }}>
      <style>{`
.lb-grain{position:absolute;inset:0;opacity:.03;pointer-events:none;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.85' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")}
      `}</style>

      {/* The floor, and nothing above it. */}
      <div style={{
        position: 'absolute', left: 0, right: 0, bottom: 0, height: '62vh',
        background: 'linear-gradient(to top,'
          + ' rgba(199,102,216,.42) 0%,'
          + ' rgba(199,155,240,.30) 26%,'
          + ' rgba(230,208,250,.16) 52%,'
          + ' transparent 100%)',
      }} />

      {/* Kept: it stops a 62vh gradient banding into visible steps on a wide
          display. Not decoration — at .03 opacity nobody sees it as texture. */}
      <div className="lb-grain" />
    </div>
  )
}

export default Ambient
